/**
 * WHO MAY WRITE TO THE TIME & EXPENSE LEDGER.
 *
 * This mirrors `WRITE_ROLES` in apps/api/src/modules/activities/activities.routes.ts. It is a
 * full member-type list rather than a subtraction, because two different roles are excluded for
 * two different reasons and neither is "everyone except pupils":
 *
 *   - `pupil` is on the route for READ ONLY — supervised learning. Pinned on the API side by
 *     pupil-access-boundary.guard.test.ts.
 *   - `staff` is not on the activities route AT ALL. Every call answers 403 "Route restricted
 *     to: admin, senior_clerk, junior_clerk, silk, junior, pupil, door_tenant". Staff inherit
 *     the admin sidebar (Sidebar.tsx shares one branch for admin and staff), so they were shown
 *     the page and both New buttons for a ledger the server refuses them outright.
 *
 * It lives here and not in `pupilUiBoundary` because that module is deliberately pupil-only —
 * "each predicate names ONLY pupil", enforced by its own test — and this rule is not about
 * pupils alone.
 *
 * The server stays authoritative. This decides only whether a control is DRAWN, so that nobody
 * is walked through a form whose save can never succeed (Rule #8).
 */

/** Member types the activities route accepts for create / edit. */
const ACTIVITY_WRITE_ROLES = [
  'admin',
  'senior_clerk',
  'junior_clerk',
  'silk',
  'junior',
  'door_tenant',
] as const;

export function canLogActivity(memberType: string | null | undefined): boolean {
  return (ACTIVITY_WRITE_ROLES as readonly string[]).includes(memberType ?? '');
}
